import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Profile_img from './../../assets/images/img.jpg';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
const selectedOptionsStyles = {
    color: "#3c763d",
    backgroundColor: "#dff0d8"
};
const optionsListStyles = {
    backgroundColor: "#dff0d8",
    color: "#3c763d"
};
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
class ViewTicket extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            ticket: '',
            reminderdate: '',
            notes: [],
            note: '',
            note1: '',
            message: '',
            message1: '',
            message2: '',
            message4: '',
            images: '',
            ticket_history: [],
            userEmail: has_local_data ? localdata.user_email : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            startaddDate: '',
            startDate: '',
            fields: {},
            errors: {},
            notedata: '',
            editnote: '',
            loading: 1,
            internal_owner: '',
            errorText: '',
            search: [],
            message5: '',
            multiSelect: [],
            hrowners: [],
            scrol: 1,
            cms_url: '',
            tattle_url: '',
            //internal_cc:0
        }
        //this.AddNoteToInternal = this.AddNoteToInternal.bind(this);
        this.onChange = this.onChange.bind(this);
        this.ckOnChange = this.ckOnChange.bind(this);
        this.ckOnChange1 = this.ckOnChange1.bind(this);
        this.closedTicket = this.closedTicket.bind(this);
        this.searchChange = this.searchChange.bind(this);
        this.multipleChangeTo = this.multipleChangeTo.bind(this);
        //this.getSelectedCcOwner = this.getSelectedCcOwner.bind(this);
        //this.getSelectedToOwner = this.getSelectedToOwner.bind(this);
        this.getSelectedOwner = this.getSelectedOwner.bind(this);
//        this.getAllOwners = this.getAllOwners.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.ckOnChangenotedit = this.ckOnChangenotedit.bind(this);
        this.handleaddChangeDate = this.handleaddChangeDate.bind(this);
        this.getSearchTicketNumber = this.getSearchTicketNumber.bind(this);
        this.handleChange = this.handleChange.bind(this);
        document.title = "Intranet | Tickets";
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    handleChange = (event, index, internal_cc) => {
        let fields = this.state.fields;
        this.setState({ internal_cc: internal_cc });
        //fields['candidate_profiles'] = value.length;
    }
    getTicketNumber(searchText = '') {
        fetch(this.state.apiUrl + '/TicketRest/getTicketsNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.tickets,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }
    getSearchTicketNumber() {
        fetch(this.state.apiUrl + '/TicketRest/getSearchTicketNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        tickets: findresponse.tickets,
                        item_count: findresponse.item_count,
                        //searchloadmore:1,
                        // isLoadMore:0
                    })
                    // alert(this.state.searchText);
                    if (this.state.item_count == 1) {
                        window.location.href = '/ticket/viewTicket/id/' + this.state.searchText;
                    }
                }
                else {
                    alert("No result found");
                }


            })
    }
    handleUpdateInput = (searchText) => {
        console.log(searchText)
        this.setState({
            searchText: searchText,
        });
        this.getTicketNumber(searchText);
    };
    handleNewRequest = (searchText) => {
        //console.log("hi" + this.state.searchText)
        this.getSearchTicketNumber();
    };
    enterKeyPress(event) {
        if (event.key == 'Enter') {
            //this.getSearchTicketNumber();
        }
    }

    handleValidation() {
        let fields = this.state.reminderdate;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.reminderdate);
        //Name
        if (!fields["reminder"]) {
            formIsValid = false;
            errors["reminder"] = "This field is required.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }
    handleaddChangeDate(date) {
        //alert(date);
        this.setState({
            startaddDate: date
        });
    }

    handleChangeDate(date) {
        this.setState({
            startDate: date
        });
    }

    closedTicket(ticketId) {
        fetch(this.state.apiUrl + '/TicketRest/closedTicket/id/' + ticketId + '/userAuthKey/' + this.state.userAuthKey + '/user_id/' + this.state.userId + '/username/' + this.state.userName)
            .then((Response) => Response.json())
            .then((findresponse) => {

                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    // window.location.href='/tickets/'; 
                    this.getTicketDetails();
                } else {

                    this.setState({ message: findresponse.msg })
                }
            })
    }
    editTicket(noteid) {
        fetch(this.state.apiUrl + '/TicketRest/EditNote/id/' + noteid + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                //console.log(findresponse)
                this.setState({
                    editnote: findresponse.notedetails,
                    noteid: findresponse.noteid
                })
            })
    }
    setNote(id, note) {
        localStorage.setItem('ticket_note', note);
        //window.location.href = '/ticket/editNote/' + id;
        this.props.history.push('/ticket/editNote/' + id);
    }
    addReminder(ticketid) {

        fetch(this.state.apiUrl + '/TicketRest/InsertReminder/ticket_id/' + ticketid + '/userid/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.getTicketDetails();
                if (findresponse.code == 200) {
                    this.setState({ message4: findresponse.msg }, function () {
                        // this.getTicketDetails();
                        window.location.href = '/ticket/viewTicket/id/' + ticketid;
                    });
                } else {

                    this.setState({ message4: findresponse.msg })
                }
            })
    }
    updateReminder(ticketid) {
        fetch(this.state.apiUrl + '/TicketRest/UpdateReminder/ticket_id/' + ticketid + '/userid/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.getTicketDetails();
                if (findresponse.code == 200) {
                    this.setState({ message5: findresponse.msg }, function () {
                        //this.getTicketDetails();
                        window.location.href = '/ticket/viewTicket/id/' + ticketid;
                    });
                } else {

                    this.setState({ message5: findresponse.msg })
                }
            })
    }
    ckOnChange(evt) {
        //console.log("onChange fired with event info: ", evt);
        var ckContent = evt.editor.getData();
        this.setState({
            note: ckContent
        })
    }
    ckOnChange1(evt) {
        //console.log("onChange fired with event info: ", evt);
        var ckContent = evt.editor.getData();
        this.setState({
            note1: ckContent
        })
    }
    ckOnChangenotedit(evt) {
        var ckContent = evt.editor.getData();
        this.setState({
            editnote: ckContent
        })
        console.log(this.state);
    }
    fileSelecthandler = (event) => {
        this.setState({ selectedFile: event.target.files[0] });
    }
    addcustomerNote() {
        document.getElementById("add_customernote").innerHTML = "Sending....";
        let img = document.getElementById('fileInput1').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('fileInput1').files[x]);
            }
        }
        document.getElementById("add_customernote").disabled = true;
        
        var internal_request = this.state;
        internal_request.owners = '';
        internal_request.hrowners = '';
        internal_request.notes = '';
        internal_request.ticket_history = '';
        fd.append('ticket_inputs', JSON.stringify(internal_request));
        
//        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/TicketRest/AddNoteToCustomer/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                
                if (findresponse.code == 200) {
                document.getElementById("add_customernote").disabled = false;
                document.getElementById("add_customernote").innerHTML = "Add Note";
//                    this.setState({ message1: findresponse.msg }, function () {
                        window.location.href = '/ticket/viewTicket/id/' + this.state.ticket.id;
                        this.getTicketDetails();
//                    });
                } else {
                    this.setState({ message1: findresponse.message }) 
                }

            })
    }
    AddNoteToInternal() {
        document.getElementById("add_note").innerHTML = "Sending....";
        let img = document.getElementById('fileInput').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('fileInput').files[x]);
            }
        }
        document.getElementById("add_note").disabled = true;
        
        var internal_request = this.state;
        internal_request.owners = '';
        internal_request.hrowners = '';
        internal_request.notes = '';
        internal_request.ticket_history = '';
        fd.append('ticket_inputs', JSON.stringify(internal_request));
        
//        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/TicketRest/AddNoteToInternal/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    localStorage.setItem('ownerid', findresponse.ticket.assigned_to);
//                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/ticket/viewTicket/id/' + this.state.ticket.id;
                        statusinter: findresponse.status;
                        //this.getTicketDetails();
//                    });
                } else {

                    this.setState({ message: findresponse.msg })
                }

            })
    }
    showImage(s3url, img) {

        if (img != '') {
            var win = window.open(s3url + img, '_blank');
            win.focus()
        }
    }
    showhelpdeskid(url, id) {
        if (id != '') {
            var win = window.open(url + id, '_blank');
            win.focus()
        }
    }
    back() {
        window.location.href = '/tickets/';
    }

    onChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    reminderupdate(propertyName, event) {
        const reminderdate = this.state.reminderdate;
        reminderdate[propertyName] = event.target.value;
        this.setState({ reminderdate: reminderdate });
    }

    reminderupdatedateonly(propertyName, event) {
        const reminderdate = this.state.reminderdate;
        reminderdate[propertyName] = event;
        this.setState({ reminderdate: reminderdate });
    }
    onChangeNote(propertyName, event) {
        const notes = this.state.notes;
        notes[propertyName] = event.target.value;
        // alert(notes[propertyName] );
        this.setState({ notes: notes });
    }


    onChangeowner(propertyName, event) {
        const ticket = this.state.ticket;
        ticket[propertyName] = event.target.value;
        this.setState({ ticket: ticket });
    }

    //   handleChangeDate(date) {
    //       alert(date);
    //     this.setState({
    //       startDate: date
    //     });
    //   }
    copylink(ticketid) {
        var selectText = this.state.cms_url + 'ticket/viewTicket/id/' + ticketid;
        var input = document.createElement('input');
        input.value = selectText;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
    }
    getTicketDetails() {
        $(document).ready(function () {
        $('.loader-new').removeClass('hidden');
                $('.intranet_body').addClass('hidden');
        });

                //redirect to tattle      
                fetch(this.state.apiUrl + '/TicketRest/Viewticket/id/' + this.props.match.params.ticketId + '/userid/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                        $(document).ready(function () {
                $('.loader-new').addClass('hidden');
                        $('.intranet_body').removeClass('hidden');
                });
                        this.setState({
                        tattle_url: responseJson.tattle_url,
                        })

                        var preview_url = this.state.tattle_url + `tattle/support-ticket/`;
                        var id = this.props.match.params.ticketId;
                        window.location.href = preview_url + id;
                        return false;
                        })
                        
//        fetch(this.state.apiUrl + '/TicketRest/Viewticket/id/' + this.props.match.params.ticketId + '/userid/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
//            .then((Response) => Response.json())
//            .then((responseJson) => {
//                responseJson = this.rawjsonparse(responseJson, 1);
//                $(document).ready(function () {
//                    $('.loader-new').addClass('hidden');
//                    $('.intranet_body').removeClass('hidden');
//                });
//                this.setState({
//                    loading: 0,
//                    ticket: responseJson.ticket,
//                    notes: responseJson.notes,
//                    studioname: responseJson.studioname,
//                    ownername: responseJson.ownername,
//                    ownerid: responseJson.ownerid,
//                    acountmanager: responseJson.acountmanager,
//                    accountmanager_id: responseJson.accountmanager_id,
//                    customer_type: responseJson.customer_type,
//                    appname: responseJson.appname,
//                    ticket_history: responseJson.ticket_history,
//                    owners: responseJson.owner,
//                    remindercondition: responseJson.reminder,
//                    reminderdate: responseJson.reminderdate,
//                    timesincelastupdate: responseJson.timesincelastupdate,
//                    storename: responseJson.storename,
//                    hrowners: responseJson.owner,
//                    scrol: this.state.scrol + 1,
//                    cms_url: responseJson.cms_url,
//                })
//
//                if (this.state.reminderdate.datetime != '0000-00-00 00:00:00') {
//                    let x = Date.parse(this.state.reminderdate.datetime);
//                    this.setState({ startDate: moment(x) })
//                }
//                
//                //Notes links to directly open by scrolling to the exact note
//                this.openNote();
//
//                            if(this.state.scrol <= 2)
//            {
//
//            const { location:{ pathname, hash}} = this.props;
//            const element = document.getElementById(hash.replace("#",""));
//
//            setTimeout( () => {
//                window.scrollTo({
//                    behavior: element ? "smooth" : 'auto',
//                    top: element ? element.offsetTop : 0
//                })
//            })
//        }
//        else
//        {
//            return false;
//        }
//                
//            })
    }
    openNote(){
        var url = window.location.href;
        let hash = url.split('#')[1];
        console.log(window.location.hash.substring(1));
        console.log(url);
        console.log(hash);
        if(hash){
            let note_id = hash;
            setTimeout(function(){ $('#'+note_id).trigger( "click" ); }, 3000);
        }
    }
    getreminderDetails() {
        fetch(this.state.apiUrl + '/TicketRest/ReminderDetails/id/' + this.props.match.params.ticketId + '/userid/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    reminder: responseJson.reminder,
                    reminderdata: responseJson.reminderdata
                })
            })
    }

    searchChange(event) {
        this.setState({ assigned_to: event.target.value }, function () {
            console.log(this.state);
            //this.ticketsList();
        });
    }
    getNotedatetime(datetime) {
        var d = new Date(datetime);
        d.setHours(d.getHours() + 3);
        var aaa = d.setMinutes(d.getMinutes() + 30);
        //return datetime;
        let time = new Intl.DateTimeFormat('en-US', {
            year: 'numeric', month: 'long', day: '2-digit', hour: 'numeric', minute: 'numeric', timeZoneName: 'short',
            timeZone: 'Asia/Kolkata',
        }).format(new Date(aaa));
        var res = time.replace("GMT+5:30", "IST");
        return res;
    }

    multipleChangeTo(e) {
        var options = e.target.options;
        //alert(options);return false;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
                console.log(options[i]);
            }
        }
        // this.props.someCallback(value);
        // this.setState({assignedinternal_to:value});
    }
    componentWillMount() {
        document.title = this.props.match.params.ticketId;
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        //this.editTicket();
        this.getTicketDetails();
//        this.getAllOwners();
        //this.getreminderDetails();

        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $(this).parent().find('.inputfile').click();
            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();
                $input.on('change', function (e) {
                    var fileName = '';
                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();
                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });
                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });
            //Show More
            $('.show-more').on('click', function () {
                if ($(this).parent().find('.hide_mob').hasClass('active')) {
                    $(this).parent().find('.hide_mob').removeClass('active');
                }
                else {
                    $(this).parent().find('.hide_mob').addClass('active');
                }
                $('.show-more span').text() === 'Show Less' ? $('.show-more span').text('Show More') : $('.show-more span').text('Show Less');
                $('.show-more .fa').toggleClass('active');
            });
        });
    }
    renderOwnerList() {
        if (this.state.hrowners) {
            return (
                <select class="form-control" name="internal_owner" id="internal_owner" onChange={this.onChangeowner.bind(this, 'assigned_to')} value={this.state.ticket.assigned_to} >
                    <option>Choose owner</option>
                    {this.state.hrowners.map((owner, i) => <option key={i} value={owner.id}>{owner.name}</option>)}
                </select>
            )
        }
        return <p>Loading owner...</p>
    }
    renderCcOwnerList() {
        if (this.state.hrowners) {
            return (
                <MuiThemeProvider muiTheme={getMuiTheme()}>
                    <SelectField
                        multiple
                        fullWidth={true}
                        value={this.state.internal_cc}
                        onChange={this.handleChange}
                        maxHeight={200}
                        className="multi"
                        placeholder="name"
                    >
                        {this.state.hrowners.map((owner, i) =>
                            <MenuItem
                                className="multi_drop"
                                value={owner.email} key={owner.email} primaryText={owner.name} />)}
                    </SelectField>
                </MuiThemeProvider>
            )
        }
        return <p>Loading owner...</p>
    }

    getSelectedOwner() {
        var selectedValues = [];
        $("#singlelistSelect :selected").each(function () {
            selectedValues.push($(this).val());
        });
        this.setState({ internal_owner: selectedValues });
        //alert(selectedValues);

    }

//    getAllOwners() {
//        fetch(this.state.apiUrl + '/TicketRest/GetOwners/userAuthKey/' + this.state.userAuthKey)
//            .then((Response) => Response.json())
//            .then((responseJson) => {
//                responseJson = this.rawjsonparse(responseJson, 1);
//                this.setState({
//                    hrowners: responseJson.owners
//                })
//            })
//    }
    getNoteStyle(internalnote) {
        if (internalnote == 1) {
            return 'sub_feedback gray'
        } else {
            return 'sub_feedback cstmr'
        }
    }
    editnoteCondition(id, note, id_user, key) {
        if (this.state.ticket.status != 'Closed') {
            if ((id_user) == (this.state.userId)) {
                return (
                    <a href="#" onClick={() => this.setNote(id, note)}> <i class="fa fa-edit"></i></a>
                )
            }
        }
    }
    getUpdateUserName(studioname, username, studio_id, id_user) {
        if (studioname != '') {
            return (<h6>{username} (<Link to={`/ViewDetail/${studio_id}`} name={"max"}>{studioname}</Link>)</h6>)
        } else {
            return (<h6><Link to={`/viewEmployee/${id_user}`} name={"max"}>{username} (Muvi)</Link></h6>)
        }
    }
    ChangeAllOwners() {
        const fd = new FormData;
        var owner = document.getElementById('internal_owner').value;
        fd.append('assign_to', owner);
        fetch(this.state.apiUrl + '/TicketRest/ChangeOwners/id/' + this.props.match.params.ticketId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        this.getTicketDetails();
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }
    // noteImage(id){
    //     alert(id);
    //     return false;
    //     fetch(this.state.apiUrl +'/TicketRest/getNoteImage/userAuthKey/'+ this.state.userAuthKey)
    //         .then((Response)=>Response.json())
    //         .then((responseJson)=>
    //         {
    //                 //console.log(responseJson)  
    //                 this.setState({
    //                     hrowners: responseJson
    //                 }) 
    //         }) 
    // }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Support" brecum_page="Ticket Detail" editnote={this.state.editnote} />
                <div class="right_col">
                    <div class="loader-new"></div>
                    <div class="intranet_body hidden">
                        <div class="title mob"><HeaderMob page_name="Ticket Detail" />
                            <div class="edit pull-right hidden-md">
                                <Link to={`/editTicket/${this.state.ticket.id}`} name={"max"}><i class="fa fa-pencil-square-o"></i></Link>
                                <div tabindex="0" class="onclick-menu edit_mob_ticket">
                                    <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                    <ul class="onclick-menu-content">
                                        <li>
                                            {this.state.remindercondition == 1 ? (<a href="javascript:void(0);" data-toggle="modal" data-target="#Modalupdatereminder">Update Reminder</a>)
                                                :
                                                (<a href="javascript:void(0);" data-toggle="modal" data-target="#Modalreminder">Add Reminder</a>)}
                                        </li>
                                        <li>
                                            {this.state.ticket.status == 'Closed' ? (<Link to={`/editTicket/${this.state.ticket.id}`} name={"max"}>Re-Open Ticket</Link>)
                                                : (<a href="javascript:void(0);" data-toggle="modal" data-target="#myModal">Close Ticket</a>)}

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="top-row border-bottom view_details support">
                            <div class="left-section btn-muvi pull-left hidden-xs">
                                {this.state.ticket.status != 'Closed' ? (<Link to={`/editTicket/${this.state.ticket.id}`} name={"max"}><button className="btn btn-sky">Edit Ticket</button></Link>)
                                    : ''
                                }
                                <Link to={`/AddErTicket/${this.state.ticket.id}`} name={"max"}><button className="btn btn-green">Add ER</button></Link>

                                {this.state.ticket.status == 'Closed' ? (<Link to={`/editTicket/${this.state.ticket.id}`} name={"max"}><button className="btn btn-blue">Re-Open Ticket</button></Link>)
                                    :
                                    (<button type="button" class="btn btn-blue" data-toggle="modal" data-target="#myModal">Close Ticket</button>)}

                                {this.state.remindercondition == 1 ? (<button type="button" class="btn btn-blue" data-toggle="modal" data-target="#Modalupdatereminder">Update Reminder</button>)
                                    :
                                    (<button type="button" class="btn btn-blue" data-toggle="modal" data-target="#Modalreminder">Add Reminder</button>)}

                                <Link to={`/tickets/`} name={"max"}> <button className="btn btn-blue" >Back</button></Link>

                            </div>
                            {/* <div class="col-md-3 pull-right">
                 <div class="searchTicket">
                 <input type="text" placeholder="Jump to ticket Number" name="search" onKeyPress={this.jumpSubmit.bind(this)}/>
                 </div>
                 <span style={{color: "red"}}> {this.state.message2}</span>
                 </div> */}

                            <div class="right-section view_search">
                                <div class="searchTicket er_dpt assgn_er">
                                    <div class="filter">
                                        <select class="form-control" name="internal_owner" id="internal_owner" onChange={this.onChangeowner.bind(this, 'assigned_to')} value={this.state.ticket.assigned_to} >
                                            <option value={this.state.userId}>[Myself] </option>
                                            {
                                                this.state.hrowners.map((dynamicData, key) =>
                                                    <option value={dynamicData.id}>{dynamicData.name}</option>
                                                )
                                            }
                                        </select>
                                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                                    </div>
                                    <button type="submit" className="btn btn-blue" onClick={() => this.ChangeAllOwners()} >Assign To</button>
                                </div>
                                <div class="react_auto">
                                    <MuiThemeProvider muiTheme={getMuiTheme()}>
                                        <AutoComplete
                                            floatingLabelText="Search ticket number"
                                            onUpdateInput={this.handleUpdateInput}
                                            onNewRequest={this.handleNewRequest}
                                            fullWidth={true}
                                            placeholder='Search ticket number'
                                            filter={AutoComplete.caseInsensitiveFilter}
                                            dataSource={this.state.search}
                                            dataSourceConfig={dataSourceConfig}
                                            errorText={this.state.errorText}
                                            maxSearchResults={8}
                                            onKeyPress={this.enterKeyPress}
                                            errorStyle={{ bottom: 0 }}
                                            className="ticket_search_box"
                                        />
                                    </MuiThemeProvider>
                                    <i class="fa fa-search"></i>
                                </div>
                            </div>
                        </div>
                        <div class="form-section border-bottom ">
                            <div className="details red">{this.state.ticket.sla == 1 ? 'SLA MISSED' : ''}</div>
                            <div class="details">
                                <div class="details_title">Title:</div>
                                <div class="details_des"><div dangerouslySetInnerHTML={{ __html: this.state.ticket.title }} /></div>
                            </div>
                            <div class="details">
                                <div class="details_title">Description:</div>
                                <div class="details_des"><div dangerouslySetInnerHTML={{ __html: this.state.ticket.description }} /></div>
                            </div>
                            <div class="details word-break">
                                <div class="details_title">Attached File:</div>
                                {this.state.ticket.attachment ?
                                    <div class="details_des"><span class="color-sky">{
                                        this.state.ticket.attachment.split(",").map(place =>
                                            <span onClick={() => this.showImage(this.state.ticket.attachment_url, place)}> {place} </span>)
                                    }</span></div>
                                    : <div class="details_des">No attachment</div>}
                            </div>
                        </div>
                        <div class="form-section ticket_details border-bottom">
                            <div class="row">
                                <div class="col-md-3 ticket-1st">
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">#Ticket Number:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.ticket.id}</span><button id="copylink" class="btn btn-blue" data-toggle="tooltip" data-placement="button" title="Copy to Clipboard" onClick={() => this.copylink(this.state.ticket.id)}>Copy Link</button></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Priority:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.ticket.priority}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Customer:</span></div>
                                        <div class="col-md-7 col-xs-6"><span><Link to={`/ViewDetail/${this.state.ticket.studio_id}`} name={"max"} className="">
                                            {this.state.studioname}</Link></span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Customer Type:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.customer_type}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Type:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{(this.state.ticket.type) ? this.state.ticket.type : "--"}</span></div>
                                    </div>
                                </div>
                                <div class="col-md-3 ticket-2nd hide_mob">
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">#ER:</span></div>
                                        <div class="col-md-7 col-xs-6"><ul className="mantis">
                                            {this.state.ticket.helpdesk_id ? this.state.ticket.helpdesk_id.split(",").map(place =>
                                                <li><a onClick={() => this.showhelpdeskid('/viewEr/', place)}> {place}</a></li>) : ""
                                            }
                                        </ul>
                                        </div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Owner:</span></div>
                                        <div class="col-md-7 col-xs-6"><span><Link to={`/viewEmployee/${this.state.ticket.assigned_to}`} name={"max"}>{this.state.ownername}</Link></span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Account Manager:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.accountmanager_id > 0 ? <Link to={`/viewEmployee/${this.state.accountmanager_id}`} name={"max"}>{this.state.acountmanager}</Link> : this.state.acountmanager}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Dev Hours:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.ticket.dev_hours}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-5 col-xs-6"><span class="bold">Escalation Level:</span></div>
                                        <div class="col-md-7 col-xs-6"><span>{this.state.ticket.escalation_level}</span></div>
                                    </div>
                                </div>
                                <div class="col-md-4 ticket-3rd hide_mob">
                                    <div class="details row">
                                        <div class="col-md-7 col-xs-6"><span class="bold">Replied:</span></div>
                                        <div class="col-md-5 col-xs-6"><span>{this.state.ticket.replied_status == 1 ? "yes" : "Not Replied"}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-7 col-xs-6"><span class="bold">Time since last update:</span></div>
                                        <div class="col-md-5 col-xs-6"><span>{this.state.timesincelastupdate}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-7 col-xs-6"><span class="bold">Last Updated:</span></div>
                                        <div class="col-md-5 col-xs-6"><span>{this.state.ticket.last_updated_date}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-7 col-xs-6"><span class="bold">Submitted:</span></div>
                                        <div class="col-md-5 col-xs-6"><span>{this.state.ticket.creation_date}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-7 col-xs-6"><span class="bold">ETA(Estimated Time):</span></div>
                                        <div class="col-md-5 col-xs-6"><span>{(this.state.ticket.eta) ? this.state.ticket.eta : "--"}</span></div>
                                    </div>
                                </div>
                                <div class="col-md-2 ticket-4th hide_mob">
                                    <div class="details row">
                                        <div class="col-md-4 col-xs-6"><span class="bold">Status:</span></div>
                                        <div class="col-md-8 col-xs-6"><span>{this.state.ticket.status}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-4 col-xs-6"><span class="bold">App:</span></div>
                                        <div class="col-md-8 col-xs-6"><span>{this.state.appname}</span></div>
                                    </div>
                                    <div class="details row">
                                        <div class="col-md-4 col-xs-6"><span class="bold">Cc:</span></div>
                                        <div class="col-md-8 col-xs-6"><span class="word-break">{this.state.ticket.ticket_email_cc ? this.state.ticket.ticket_email_cc : 'N/A'}</span></div>
                                    </div>
                                </div>
                                <div class="show-more hidden-md"><i class="fa fa-angle-double-down"></i><span>Show More</span></div>
                            </div>
                        </div>
                        <div class="reply_customer">
                            <ul class="nav nav-tabs">
                                <li class="active"><a class="internal_selected" href="#a" data-toggle="tab"><span></span>Internal Only</a></li>
                                <li><a class="customer_selected" href="#b" data-toggle="tab"><span></span>Reply to Customer</a></li>
                            </ul>

                            <div class="tab-content">
                                <div class="tab-pane active" id="a">

                                    <div className="row">

                                        <div className="col-md-6 col-xs-12">
                                            To: {this.renderOwnerList()}
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            Cc: {this.renderCcOwnerList()}
                                        </div>
                                        <div class="clearfix"></div>
                                        <div className="form-section ckeditor">
                                            <CKEditor
                                                activeClass="p10"
                                                content={this.state.note}
                                                events={{
                                                    "change": this.ckOnChange
                                                }}
                                            />
                                        </div>
                                        <div className="form-section ckeditor_upload">
                                            <div class="field" align="left">
                                                {/* <input type="file" name="fileInput" id="fileInput" multiple onChange={this.fileSelecthandler} /> */}
                                                <div class="upload">
                                                    <label>Add Attachment :</label>
                                                    <div class="upload_btn">
                                                        <input type="file" name="file-1[]" id="fileInput" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                        <label for="file-1">
                                                            <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                                            <span>Choose file</span>
                                                            <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-section ckeditor">
                                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.AddNoteToInternal()}>Add Note</button>
                                        </div>
                                    </div>
                                    <div class="red">{this.state.message}</div>
                                </div>
                                <div class="tab-pane" id="b">
                                    <div className="row">

                                        <div className="form-section ckeditor">

                                            {/* <textarea name="note" id="note" rows="4" cols="50" onChange={this.onChange}></textarea>   */}
                                            <CKEditor
                                                activeClass="p10"
                                                content={this.state.note1}
                                                events={{
                                                    "change": this.ckOnChange1
                                                }}
                                            />
                                        </div>

                                        <div className="form-section ckeditor_upload">
                                            {/* <input type="file" name="fileInput1" id="fileInput1" multiple onChange={this.fileSelecthandler} /> */}

                                            <div class="upload">
                                                <label>Add Attachment :</label>
                                                <div class="upload_btn">
                                                    <input type="file" name="file-1[]" id="fileInput1" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                                    <label for="file-1">
                                                        <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                                        <span>Choose file</span>
                                                        <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-section ckeditor">
                                            <button type="submit" name="add_customernote" id="add_customernote" className="btn btn-sky mob-btn" onClick={() => this.addcustomerNote()}>Add Note</button>
                                        </div>
                                        <span style={{ color: "red" }}>  {this.state.message1}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="add_note_history">
                            <div class="feedback">
                                <div class="feedback-color-intruction">
                                    <div class="sub_feedback_note tltle">
                                        Notes
                                </div>
                                    <div class="sub_feedback_grey status_block instruction_gry ">
                                        Internal
                                </div>
                                    <div class="sub_feedback_cstmr status_block instruction_cstmr ">
                                        Customer
                                </div>
                                </div>
                                {
                                    this.state.notes.map((data, key) =>
                                        <div class={this.getNoteStyle(data.Internal)} id={'note' + data.id}>
                                            <div class="main">
                                                <div class="pro_image">
                                                    <span class="profile_first_name"> {data.user_name.charAt(0).toUpperCase()}</span>
                                                </div>
                                                {this.getUpdateUserName(data.studio_name, data.user_name, data.studio_id, data.id_user)}
                                                <span>{data.Internal == 1 ? "Added By Internal - " : ""} {data.add_date}</span>
                                                <div class="fa-icon tooltips">
                                                    {this.editnoteCondition(data.id, data.note, data.id_user, key)}
                                                </div>
                                            </div>
                                            <div class="sub">
                                                <a href={'#note' + data.id} key={key} to={data.id} name={'note' + data.id} id={'note' + data.id}><span>Note {data.id}</span></a>
                                                <p><div dangerouslySetInnerHTML={{ __html: data.note }} /></p>
                                            </div>
                                            <div class="details_des"><span class="color-sky">
                                                {
                                                    data.attachment ? data.attachment.split(",").map(place =>
                                                        <div class="note_wrap" onClick={() => this.showImage(data.attachment_url, place)}> {place} </div>
                                                    ) : ""
                                                }
                                            </span>
                                            </div>

                                        </div>
                                    )
                                }
                            </div>

                            <div class="tickets">
                                <h5 class="title"><span>Ticket History</span></h5>
                                <ul class="tickets_head">
                                    <li class="intra_col_25">Date</li>
                                    <li class="intra_col_25">User</li>
                                    <li class="intra_col_25">Field</li>
                                    <li class="intra_col_25">Content</li>
                                </ul>
                                {
                                    this.state.ticket_history.map((tiHistory, key) =>
                                        <ul class="tickets_number">
                                            {/* <li class="w_25">{tiHistory.created_date } </li> */}
                                            {/* <li class="w_25">{this.getNotedatetime(tiHistory.created_date)}</li> */}
                                            <li class="intra_col_25">{tiHistory.created_date}</li>
                                            <li class="intra_col_25"> {tiHistory.type == 1 ? <Link to={`/viewEmployee/${tiHistory.user_id}`} name={"max"}>{tiHistory.user_name}</Link> : tiHistory.user_name}</li>
                                            <li class="intra_col_25">{tiHistory.field} => {tiHistory.action}</li>
                                            <li class="intra_col_25 word-break"> {((tiHistory.field == 'title') || (tiHistory.field == 'description') || (tiHistory.object_type == 'Note')) ? (<Link to={`/HistoryDetails/${tiHistory.id}`} name={"max"}><span class="color-sky">View Revisions</span></Link>) : tiHistory.object_content}</li>
                                        </ul>
                                    )
                                }

                            </div>
                        </div>
                    </div>
                    {/* <--modal start for note edit-!> */}
                    <div class="modal fade" id="editModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Update Note</h4>
                                </div>
                                <div class="modal-body">
                                    {/* <p> {this.state.notedetails}</p> */}
                                    {/* <textarea class="form-control" rows="5" name="note" value={this.state.notedetails} onChange={this.onChangeNote.bind(this, 'note')}>
                         </textarea> */}
                                    <CKEditor
                                        activeClass="p10"
                                        content={this.state.editnote}
                                        //value={this.state.editnote}
                                        events={{
                                            "change": this.ckOnChangenotedit
                                        }}
                                    />
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sky" data-dismiss="modal" onClick={() => this.updatenote(this.state.noteid)}>Update</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--modal start-!> */}

                    {/* <--modal start-!> */}
                    <div class="modal fade" id="myModal" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Close Ticket</h4>
                                </div>
                                <div class="modal-body">
                                    <p>Are you sure to close this ticket?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sky" data-dismiss="modal" onClick={() => this.closedTicket(this.state.ticket.id)}>Yes</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <--modal start-!> */}

                    {/* <--modal start for reminder-!> */}
                    <div class="modal fade" id="Modalreminder" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">

                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Add Reminder</h4>
                                </div>
                                <div class="modal-body">

                                    <input type="text" class="form-control" name="reminder" id="reminder" placeholder="Remind me about" onChange={this.onChange} required />
                                    <br />
                                    <div class="icon-live icon-date-reminder">
                                        <DatePicker
                                            id="startdate"
                                            minDate={moment()}
                                            // minTime={moment().hours(5).minutes(30)}
                                            readOnly={true}
                                            selected={this.state.startaddDate}
                                            onChange={this.handleaddChangeDate}
                                            timeIntervals={15}
                                            showTimeSelect
                                            dateFormat="LLL" />
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                    </div>
                                    <br />
                                    {/* <input type="datetime-local" class="form-control" name="datetimepicker" id="datetimepicker" placeholder="Remind me Date" onChange={this.onChange}/><br/> */}
                                    <textarea id="reminder_description" class="form-control" name='reminder_description' placeholder="Reminder Description" rows="4" onChange={this.onChange} required></textarea>
                                    <div class="form-group">
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="1" type="radio" name="remindertime" value="15" onChange={this.onChange} />
                                            <label for="1">
                                                <span></span>
                                                Remind after 15 minutes
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="2" type="radio" name="remindertime" value="30" onChange={this.onChange} />
                                            <label for="2">
                                                <span></span>
                                                Remind after 30 minutes
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="3" type="radio" name="remindertime" value="60" onChange={this.onChange} />
                                            <label for="3">
                                                <span></span>
                                                Remind after 1 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="4" type="radio" name="remindertime" value="120" onChange={this.onChange} />
                                            <label for="4">
                                                <span></span>
                                                Remind after 2 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="5" type="radio" name="remindertime" value="180" onChange={this.onChange} />
                                            <label for="5">
                                                <span></span>
                                                Remind after 3 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" id="6" type="radio" name="remindertime" value="240" onChange={this.onChange} />
                                            <label for="6">
                                                <span></span>
                                                Remind after 4 hour
                            </label>
                                        </div>
                                        <span style={{ color: "red" }}>{this.state.message4}</span>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sky" onClick={() => this.addReminder(this.state.ticket.id)}>Save</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                </div>

                            </div>

                        </div>
                    </div>
                    {/* <--modal start-!> */}

                    {/* <-update -modal start for reminder-!> */}
                    <div class="modal fade" id="Modalupdatereminder" role="dialog">
                        <div class="modal-dialog modal-md">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                    <h4 class="modal-title">Update Reminder</h4>
                                </div>
                                <div class="modal-body">

                                    <input type="text" class="form-control" name="reminder" value={this.state.reminderdate.title} placeholder="Remind me about" onChange={this.reminderupdate.bind(this, 'title')} />
                                    <br />


                                    <DatePicker
                                        readOnly={true}
                                        id="startdate"
                                        minDate={moment()}
                                        selected={this.state.startDate}
                                        onChange={this.handleChangeDate}
                                        timeIntervals={15}
                                        showTimeSelect
                                        dateFormat="LLL" />
                                    <br />
                                    <textarea class="form-control" name='reminder_description' placeholder="Reminder Description" value={this.state.reminderdate.description} rows="4" onChange={this.reminderupdate.bind(this, 'description')}></textarea>
                                    <div class="form-group">
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="10" name="remindertime" value="15" checked={this.state.reminderdate.aftertime === '15'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="10">
                                                <span></span>
                                                Remind after 15 minutes
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="11" name="remindertime" value="30" checked={this.state.reminderdate.aftertime === '30'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="11">
                                                <span></span>
                                                Remind after 30 minutes
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="12" name="remindertime" value="60" checked={this.state.reminderdate.aftertime === '60'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="12">
                                                <span></span>
                                                Remind after 1 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="13" name="remindertime" value="120" checked={this.state.reminderdate.aftertime === '120'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="13">
                                                <span></span>
                                                Remind after 2 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="14" name="remindertime" value="180" checked={this.state.reminderdate.aftertime === '180'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="14">
                                                <span></span>
                                                Remind after 3 hour
                            </label>
                                        </div>
                                        <div class="radio feature-check">
                                            <input class="valid_fld" type="radio" id="15" name="remindertime" value="240" checked={this.state.reminderdate.aftertime === '240'} onChange={this.reminderupdate.bind(this, 'aftertime')} />
                                            <label for="15">
                                                <span></span>
                                                Remind after 4 hour
                            </label>
                                        </div>
                                        <span style={{ color: "red" }}>{this.state.message5}</span>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-sky" onClick={() => this.updateReminder(this.state.ticket.id)}>Save</button>
                                    <button type="button" class="btn btn-blue" data-dismiss="modal">No</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    {/* <--modal start-!> */}

                </div>
            </div>

        )
    }
}
export default ViewTicket;



// WEBPACK FOOTER //
// ./src/components/support/ViewTicket.js